import { useState } from "react";

const useOpenClose = <T = Record<string, any>>() => {
  const [isOpen, setIsOpen] = useState(false);
  const [extraData, setExtraData] = useState<T>({} as T);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const updateExtra = (data: Partial<T>) => setExtraData((st) => ({ ...st, ...data }));

  return {
    isOpen,
    extraData,
    open,
    close,
    updateExtra,
  };
};

export default useOpenClose;
